var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42332 15.7976L0.317449 8.69312C0.202853 8.5776 0.121065 8.46716 0.0720846 8.36181C0.0240283 8.25553 0 8.14463 0 8.02911C0 7.91359 0.0240283 7.80269 0.0720846 7.69641C0.121065 7.59106 0.202853 7.48062 0.317449 7.3651L7.48016 0.17328C7.59568 0.0577601 7.72552 0 7.86969 0C8.01479 0 8.15434 0.0771672 8.28834 0.231502C8.40478 0.36643 8.45792 0.511061 8.44776 0.665396C8.43851 0.818807 8.37613 0.953272 8.26061 1.06879L1.87836 7.42194H15.4802C15.6151 7.42194 15.7449 7.48478 15.8697 7.61047C15.9954 7.73523 16.0582 7.87478 16.0582 8.02911C16.0582 8.18345 15.9954 8.31837 15.8697 8.43389C15.7449 8.54941 15.6151 8.60717 15.4802 8.60717H1.87836L8.28834 15.0185C8.40478 15.1341 8.463 15.2542 8.463 15.379C8.463 15.5046 8.39554 15.6442 8.26061 15.7976C8.12569 15.9325 7.98614 16 7.84197 16C7.69687 16 7.55733 15.9325 7.42332 15.7976Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.d506abfcf22a361c374fa2c5f92f1fde.svg";
export { ForwardRef as ReactComponent };